import React from 'react'
import { connect } from 'react-redux'
import {
  getCurrencySelectData,
  getCurrencyCode,
  getFeaturedCurrencies,
  getLanguageCode,
} from 'tickets/redux/modules/user/selectors'
import { getSupportedLanguageCodes } from 'common/utils/context'
import userOperations from 'tickets/redux/modules/user/operations'
import UserPreferencesDropDown from 'common/components/inputs/UserPreferencesDropDown'

const mapStateToProps = state => ({
  currencyData: getCurrencySelectData(state),
  featuredCurrencies: getFeaturedCurrencies(state),
  selectedCurrency: getCurrencyCode(state),
  supportedLanguageCodes: getSupportedLanguageCodes(),
  selectedLanguage: getLanguageCode(state),
})

const mapDispatchToProps = {
  onCurrencyClick: userOperations.currencyChanged,
  onLanguageClick: userOperations.languageChanged,
}

const UserPreferencesDropDownContainer = props => (
  <UserPreferencesDropDown
    ref={(userPreferencesDropDown) => { window.userPreferencesDropDown = userPreferencesDropDown }}
    {...props}
  />
)

export default connect(
    mapStateToProps,
    mapDispatchToProps,
  )(UserPreferencesDropDownContainer)
